// hooks/useGetSubjects.js
import { useState, useEffect } from 'react';
import { subjectService } from '../Services/subjectService';
import { useDispatch } from 'react-redux';
import { setSnackError } from '../Reducers/snackErrors';
import { setSuccessSnack } from '../Reducers/snackSuccess';
import { handleApiError } from '../Utils/ApiErrorHandler';

const useGetSubjects = (role) => {
    const dispatch = useDispatch();
    const [subjects, setSubjects] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState(false);



    const [creating, setCreating] = useState(false);
    const [updating, setUpdating] = useState(false);

    // Add these functions:
    const createSubject = async (values) => {
    try {
        setCreating(true);
        const data = await subjectService.createSubject(values);
        
        if (data.status === 'OK') {
        dispatch(setSuccessSnack({
            title: 'Success', 
            body: `Created new subject with id ${data.id}`
        }));
        await fetchSubjects(); // Refresh list
        return true;
        }
        return false;
    } catch (error) {
        handleApiError(error, dispatch, 'create subject');
        return false;
    } finally {
        setCreating(false);
    }
    };

    const updateSubject = async (values) => {
    try {
        setUpdating(true);
        const data = await subjectService.updateSubject(values);
        
        if (data.status === 'Updated') {
        dispatch(setSuccessSnack({
            title: 'Success', 
            body: `Updated subject with id ${data.id}`
        }));
        await fetchSubjects(); // Refresh list
        return true;
        }
        return false;
    } catch (error) {
        handleApiError(error, dispatch, 'update subject');
        return false;
    } finally {
        setUpdating(false);
    }
    };

  const fetchSubjects = async () => {
    if (!role?.id) return null;

    try {
      setLoading(true);
      const data = await subjectService.getSubjects();
      setSubjects(data);
      return data;
    } catch (error) {
      handleApiError(error, dispatch, 'get subjects');
      return null;
    } finally {
      setLoading(false);
    }
  };

  const deleteSubject = async (id) => {
    if (!id) return false;

    try {
      setDeleting(true);
      const data = await subjectService.deleteSubject(id);
      
      if (data.status === 'Removed') {
        dispatch(setSuccessSnack({
          title: 'Success', 
          body: 'Removed subject'
        }));
        await fetchSubjects(); // Refresh list
        return true;
      }
      return false;
    } catch (error) {
      handleApiError(error, dispatch, 'delete subject');
      return false;
    } finally {
      setDeleting(false);
    }
  };

  useEffect(() => {
    if (role?.id) {
      fetchSubjects();
    }
  }, [role?.id]);

  return {
    creating,
    updating,
    subjects,
    loading,
    deleting,
    refetch: fetchSubjects,
    deleteSubject,
    createSubject,
    updateSubject
  };
};

export default useGetSubjects;